import cn  from './cn.json'; // 中文简体
import zh  from './zh.json'; // 中文繁体
import en  from './en.json'; // 英语
import idn from './idn.json';// 印尼语
import mys from './mys.json';// 马来语
import tha from './tha.json';// 泰语
import vnm from './vnm.json';// 越南语

export default {
	cn,
	zh,
	en,
	idn,
	mys,
	tha,
	vnm
}
